import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { unregister } from './registerServiceWorker';
import { BrowserRouter } from 'react-router-dom';

const app = <BrowserRouter>
                <App />
            </BrowserRouter>
            
const baseElement = document.createElement('base')
baseElement.setAttribute('target', '_blank')
document.head.appendChild(baseElement)

ReactDOM.render(app, document.getElementById('root'));
unregister();
// register();



// WEBPACK FOOTER //
// ./src/index.js